import React from 'react'
import moment from 'moment'
import { Button, Label, Image, Divider } from 'semantic-ui-react'

const imagePlaceholder = require('../../../assets/images/placeholder-480.png')

export default class AppInboxRow extends React.PureComponent {
  convertTime = timestamp => {
    return moment(Number(timestamp)).format('DD-MMM-YYYY HH:mm a')
  }

  render() {
    const { onEdit, onDelete, data } = this.props
    const { image, title, description, restaurant, expired_at: expiredAt, start_from: startFrom } = data
    const imageScr = image || imagePlaceholder

    return (
      <div style={{ marginTop: 20 }}>
        <div className="row-wrapper">
          <div style={{ marginRight: 20 }}>
            <div style={{ width: 160, height: 90, position: 'relative' }}>
              <Image
                src={imageScr}
                size="tiny"
                rounded
                verticalAlign="middle"
                style={{ width: 140, height: 80 }}
              />
            </div>
          </div>

          <div className="column">
            <div>{title.en}</div>
            <div style={{ color: 'gray', marginTop: 6 }} className="textOverflow">
              {description.en}
            </div>
          </div>

          <div className="column">
            <div>
              {startFrom !== null ? `Start at ${this.convertTime(startFrom)}` : null}
            </div>
            <div style={{ color: 'gray', marginTop: 6 }}>
              {expiredAt !== null ? `Expire at ${this.convertTime(expiredAt)}` : null}
            </div>
          </div>

          <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            {restaurant && <Label color="teal" tag>{restaurant.label}</Label>}
          </div>

          <Button.Group vertical labeled size='tiny' style={{ justifyContent: 'flex-end' }}>
            <Button content='Edit' style={{ marginBottom: 2 }} onClick={onEdit}/>
            <Button color='red' content='Delete' onClick={onDelete} />
          </Button.Group>
        </div>
        <Divider />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/appInbox/components/row.js